import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdateProfile } from '../../services/python-api/authHooks.js';

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within TourProvider');
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const [isTourActive, setIsTourActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [showWelcome, setShowWelcome] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const navigate = useNavigate();
  const updateProfileMutation = useUpdateProfile();


  const startTour = (steps) => {
    setTourSteps(steps);
    setShowWelcome(true);
  };

  const beginTour = () => {
    setShowWelcome(false);
    setIsTourActive(true);
    setCurrentStep(0);
    // Navigate to first step
    if (tourSteps[0]?.route) {
      navigate(tourSteps[0].route);
    }
  };

  const endTour = async () => {
    setShowWelcome(false);
    setIsTourActive(false);
    setCurrentStep(0);
    setTourSteps([]);
    
    try {
      await updateProfileMutation.mutateAsync({ completed_tour: true });
    } catch (error) {
      console.error('Failed to update tour status:', error);
    }
  };

  const nextStep = () => {
    if (currentStep < tourSteps.length - 1) {
      const nextStepIndex = currentStep + 1;
      const nextStepData = tourSteps[nextStepIndex];
      
      // Navigate to the required page if specified
      if (nextStepData.route) {
        navigate(nextStepData.route);
      }
      
      setCurrentStep(nextStepIndex);
    } else {
      endTour();
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      const prevStepIndex = currentStep - 1;
      const prevStepData = tourSteps[prevStepIndex];
      
      // Navigate to the required page if specified
      if (prevStepData.route) {
        navigate(prevStepData.route);
      }
      
      setCurrentStep(prevStepIndex);
    }
  };

  return (
    <TourContext.Provider
      value={{
        isTourActive,
        currentStep,
        showWelcome,
        tourSteps,
        startTour,
        beginTour,
        endTour,
        nextStep,
        prevStep,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};